export default "__VITE_ASSET__7894056b__"